import { FC, ComponentProps } from 'react';
import { Flex, BoxV2 as Box } from 'portal-commons';

interface InfoItemProps {
  title?: string;
  itemWidths?: string[];
  titleSx?: ComponentProps<typeof Flex>['sx'];
  disableFallback?: boolean;
}

type Props = InfoItemProps &
  Omit<ComponentProps<typeof Flex>, keyof InfoItemProps>;

const InfoItem: FC<Props> = ({
  title,
  children,
  itemWidths = ['180px', 'calc(100% - 180px)'],
  sx,
  titleSx,
  disableFallback,
  ...flexProps
}) => {
  return (
    <Flex
      sx={{
        flex: 1,
        fontSize: 'H300',
        fontWeight: 'semiBold',
        color: 't.black70',
        '> label ~ div': {
          width: itemWidths[1],
          wordBreak: 'break-all',
        },
        ...sx,
      }}
      {...flexProps}
      data-testid="infoItem"
    >
      {!!title && (
        <Box
          as="label"
          sx={{ fontWeight: 'normal', width: itemWidths[0], ...titleSx }}
        >
          {title}:
        </Box>
      )}
      <div>{children || (disableFallback ? null : 'N/A')}</div>
    </Flex>
  );
};

export default InfoItem;
